<template>
  <div style="background-color: #fff; border-radius: 10px; overflow: hidden">
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240)"
      title="返回"
      @back="$router.go(-1)"
    />
    <div class="steps-container">
      <a-steps :current="current">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
      </a-steps>
      <div class="steps-content">
        <component
          :is="steps[current].content"
          @nextClick="next"
          @prevClick="prev"
          :quesData="quesData"
          :evaluationId="evaluationId"
          @refreshQuesData="getQuesData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CreateQuesForm from './components/CreateQuesForm'
import CreateQuesTopic from './components/CreateQuesTopic'
import CreateQuesRule from './components/CreateQuesRule'
import { getAction } from '@api/manage'

export default {
  name: 'QuestionnaireSystem',
  components: {
    CreateQuesForm,
    CreateQuesTopic,
    CreateQuesRule,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: '创建量表',
          content: 'CreateQuesForm',
        },
        {
          title: '创建/编辑题目',
          content: 'CreateQuesTopic',
        },
        {
          title: '创建规则',
          content: 'CreateQuesRule',
        },
      ],
      quesData: {},
      evaluationId: '',
    }
  },
  created() {
    this.getQuesData()
  },
  methods: {
    next(evaluationId) {
      this.current++
      if (evaluationId) {
        this.evaluationId = evaluationId
      }
    },
    prev() {
      this.current--
    },
    getQuesData(evaluationId) {
      const id = this.$route.query.id || evaluationId
      console.log('id', id)
      if (id) {
        getAction('/schoolEvaluation/queryById', { id }).then((res) => {
          if (res.success) {
            this.quesData = res.result
            this.evaluationId = res.result.id
          }
        })
      }
    },
  },
}
</script>
<style scoped lang="less">
.steps-container {
  max-height: 85vh;
  padding: 20px;
  overflow: hidden;
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translate(-100%, -100px) scale(0.8);
    }
    to {
      opacity: 1;
      transform: translate(0, 0) scale(1);
    }
  }
  .steps-content {
    height: 100%;
    padding: 20px;
    animation: fadeIn 0.5s ease-in-out;
  }
}
</style>
